import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53b1fb0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "course__img" }, null, -1))
const _hoisted_2 = { class: "course__container" }
const _hoisted_3 = { class: "course__information--title" }
const _hoisted_4 = {
  key: 0,
  class: "inactive"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flag" }, "Presencial", -1))
const _hoisted_6 = { class: "course__information--details" }
const _hoisted_7 = { class: "details" }
const _hoisted_8 = { class: "details" }
const _hoisted_9 = { class: "details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.training.name) + " ", 1),
        (_ctx.isInactive(_ctx.training))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Inativo"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5,
      (_ctx.training.haveCertification && _ctx.training.percentage >= 75)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openCertificate(_ctx.training.id)), ["stop"])),
            class: _normalizeClass(['certification', { inactive: _ctx.isInactive(_ctx.training) }])
          }, " visualizar certificado ", 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, "Local: " + _toDisplayString(_ctx.getMenusLocation(_ctx.training.menus)), 1),
        _createElementVNode("span", _hoisted_8, "Datas: " + _toDisplayString(_ctx.formatMenusDates(_ctx.training.menus)), 1),
        _createElementVNode("span", _hoisted_9, " Horários: " + _toDisplayString(_ctx.formatMenusSchedule(_ctx.training.menus)), 1)
      ])
    ])
  ], 64))
}